import { render } from "./footerComp.vue?vue&type=template&id=766cbf38"
import script from "./footerComp.vue?vue&type=script&lang=js"
export * from "./footerComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__